import {useTranslation} from 'react-i18next';

import {LoginBackground} from './LoginBackground';

import type {FC, ReactNode} from 'react';

interface AuthLoadingScreenProps {
  background?: ReactNode;
}

/** The login background with a screen-reader loading status; needs `loading` in `common`. */
export const AuthLoadingScreen: FC<AuthLoadingScreenProps> = ({background}) => {
  const {t} = useTranslation('common');

  return (
    <LoginBackground background={background}>
      <span role="status" className="sr-only">
        {t('loading')}
      </span>
    </LoginBackground>
  );
};
